var map = {
	"./Ansar.svg": 2378,
	"./Arman.svg": 806,
	"./Ayandeh.svg": 3727,
	"./Bank-Hekmat.svg": 2427,
	"./Bank-Markazi.svg": 1379,
	"./Day.svg": 3707,
	"./Eghtesad.svg": 3278,
	"./Gardeshgari.svg": 1415,
	"./Ghavamin.svg": 7673,
	"./Iranzamin.svg": 606,
	"./Karafarin.svg": 6579,
	"./Khavarmiane.svg": 4719,
	"./Kosar.svg": 7990,
	"./Maskan.svg": 4327,
	"./Mehr-Eghtesad.svg": 3257,
	"./Mehr.svg": 5354,
	"./Mellat.svg": 4808,
	"./Melli.svg": 3307,
	"./Parsian.svg": 8977,
	"./Pasargad.svg": 6112,
	"./Refah.svg": 4921,
	"./Resalat.svg": 2533,
	"./Saderat.svg": 3267,
	"./Salehin.svg": 9328,
	"./Saman.svg": 1423,
	"./Samen.svg": 7175,
	"./Sanatvamadan.svg": 1110,
	"./Sarmayeh.svg": 1626,
	"./Sepah.svg": 545,
	"./Shahr.svg": 2333,
	"./Shaparak.svg": 563,
	"./Shetab.svg": 9635,
	"./Sina.svg": 1345,
	"./Tejarat.svg": 6775,
	"./Tosee-Saderat.svg": 3793,
	"./Tosee-Taavon.svg": 4414,
	"./Tosee.svg": 9961,
	"./keshavarzi.svg": 4559,
	"./postbank.svg": 7281
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4406;